import {Big} from 'big.js';

export class ProductPricing {

    public id: number;
    public p90: string;
    public p50p90: string;
    public p50: string;
    public p10p50: string;
    public p10: string;
    public r7090: string;
    public r5090: string;
    public r3090: string;
    public r1090: string;
    public type: string;
    public productPricingDetails: Record<string, any>;

    public recalculateFromPcc(pcc: Big, catalogPrice: Big, coeff: Big): ProductPricing {
        const P50 = pcc.add(catalogPrice).div(new Big(2));
        const P50P90 = P50.add(catalogPrice).div(new Big(2));
        const P10P50 = pcc.add(P50).div(new Big(2));
        return {
            ...this,
            p90:    catalogPrice.mul(coeff).toFixed(3),
            p50p90: P50P90.mul(coeff).toFixed(3),
            p50:    P50.mul(coeff).toFixed(3),
            p10p50: P10P50.mul(coeff).toFixed(3),
            p10:    pcc.mul(coeff).toFixed(3),
        };
    }

    public recalculateCorridors(greenPrice: string, blackPrice: string): ProductPricing {
        if (!greenPrice || !blackPrice) {
            return null;
        }

        const _greenPrice = new Big(greenPrice);
        const _blackPrice = new Big(blackPrice);
        const P50 = _blackPrice.add(_greenPrice).div(new Big(2));
        const P50P90 = P50.add(_greenPrice).div(new Big(2));
        const P10P50 = _blackPrice.add(P50).div(new Big(2));
        return {
            ...this,
            p90: _greenPrice.toFixed(3),
            p50p90: P50P90.toFixed(3),
            p50: P50.toFixed(3),
            p10p50: P10P50.toFixed(3),
            p10: _blackPrice.toFixed(3),
        };
    }
}

